import { Box } from '@chakra-ui/layout'
import { connectNetwork } from 'lib/NetworkProvider'
import View from 'lib/View'
import moment from 'moment-timezone'
import 'moment/locale/it'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Button, Dimmer, Form, Input, Loader, Message, Placeholder, TextArea } from 'semantic-ui-react'
import { baseViewDispatch, createAlert } from '../lib/util'
function MoldEditor({ network, moldId, onSave, onCancel, defaultDescription, error, hide, info, removeAll, show, success, warning }) {
    const [mold, setMold] = useState(null)
    const [status, setStatus] = useState(null)
    const [dirty, setDirty] = useState(false)

    useEffect(() => {
        if (moldId) {
            network.getMold(moldId).then((data) => {
                // console.log('Got mold', data.data)
                setMold(data.data)
            })
        } else {
            setMold({
                moldCode: '',
                moldDescription: defaultDescription ? defaultDescription : 'Descrizione',
            })
        }
    }, [moldId])

    const handleInput = (event) => {
        const target = event.target
        const value = target.type === 'checkbox' ? target.checked : target.value
        const name = target.name

        setMold({
            ...mold,
            [name]: value,
        })
    }

    const save = () => {
        network
            .createMold(moldId, mold)
            .then((data) => {
                // console.log('Got mold', data.data)
                setMold(data.data)
            })
            .then((result) => {
                success(createAlert('Operazione completata.', 'Operazione avvenuta con successo!', 'Ok', () => {}))
                setStatus('success')
                if (onSave) {
                    onSave(result)
                }
            })
            .catch((err) => {
                error(createAlert('Errore durante il salvataggio', 'Il codice stampo deve essere UNIVOCO'))
                setStatus('error')
            })
    }

    if (!mold) {
        return (
            <Box p={6}>
                <Dimmer active>
                    <Loader />
                </Dimmer>

                <Placeholder>
                    <Placeholder.Header image>
                        <Placeholder.Line />
                        <Placeholder.Line />
                    </Placeholder.Header>
                    <Placeholder.Paragraph>
                        <Placeholder.Line />
                        <Placeholder.Line />
                        <Placeholder.Line />
                        <Placeholder.Line />
                    </Placeholder.Paragraph>
                </Placeholder>
            </Box>
        )
    }

    const { moldCode, moldDescription } = mold

    return (
        <View fullw fullh column between style={{ marginTop: 20, paddingLeft: 20, paddingRight: 20 }}>
            <Form success={status === 'success'} error={status === 'error'} warning={status === 'warning'}>
                <Box p={6}>
                    <Box textStyle="header" as="h1">Anagrafica stampo</Box>
                    <Form.Group widths="equal">
                        <Form.Field
                            id="form-input-control-mold-code"
                            control={Input}
                            label={<span className="label">Codice stampo</span>}
                            name="moldCode"
                            value={moldCode}
                            onChange={(e) => handleInput(e)}
                            placeholder=""
                            required={true}
                        />
                    </Form.Group>
                    <Form.Group widths="equal">
                        <Form.Field
                            id="form-input-control-mold-name"
                            control={TextArea}
                            label={<span className="label">Descrizione Stampo</span>}
                            name="moldDescription"
                            value={moldDescription}
                            onChange={(e) => handleInput(e)}
                            placeholder=""
                        />
                    </Form.Group>
                </Box>

                <Form.Group>
                    <Form.Field
                        style={{ marginTop: 16 }}
                        id="form-button-control-save"
                        control={Button}
                        content="Salva"
                        onClick={() => {
                            save()
                        }}
                        color="green"
                    />
                    <Form.Field
                        style={{ marginTop: 16 }}
                        id="form-button-control-cancel"
                        control={Button}
                        content="Annulla"
                        onClick={() => {
                            if (onCancel) {
                                onCancel()
                            }
                        }}
                        color="red"
                    />
                </Form.Group>
                <Message success header="Form completato con successo" content="Stampo inserito con successo!" />
                <Message error header="Errore" content="Errore: Il codice stampo deve essere univoco." />
                <Message warning header="Errore inserimento" list={['Ricontrolla i dati inseriti']} />
            </Form>
        </View>
    )
}

const mapStateToProps = (state, ownProps) => {
    let { login } = state

    return {
        login,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        ...baseViewDispatch(dispatch),
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(connectNetwork(MoldEditor)))
